import { OnboardingStep } from '~apis/settings';

const checkIsOnboardingUser = (onboardingStep?: keyof typeof OnboardingStep) => {
  if (onboardingStep == null) {
    return false;
  }

  return OnboardingStep[onboardingStep] < OnboardingStep.ONBOARDED;
};

export default checkIsOnboardingUser;
